<template>
  <div class="container">
    <div class="select-container">
      <div class="close-btn" @click="$emit('close')">
        <font-awesome-icon :icon="['fas', 'window-close']" />
      </div>
      <p class="top-text">
        Leave this box blank to save this layout with the current name ({{
          existingName
        }}).
      </p>
      <div class="content">
        <label for="layout_name">Layout Name</label>
        <input
          :placeholder="isCreator"
          type="text"
          name="layout_name"
          v-model="boardName"
          required
        />
      </div>
      <p class="top-text" style="color: red" v-if="willOverwrite">
        Choosing this name will overwrite one of your other layouts.
      </p>
      <button class="save-btn" @click="saveLayout()">Save</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      boardName: "",
    };
  },

  computed: {
    existingName() {
      return this.$store.getters.boardName;

    },

    existingId() {
      return this.$store.getters.currentLayout;
    },

    willOverwrite() {
      return (
        this.existingNames.findIndex((x) => x.name == this.boardName) !== -1
      );
    },

    existingNames() {
      return this.$store.getters.layoutCollection.filter(
        (x) => x.createdBy && x.name != this.existingName
      );
    },
    isCreator(){
      return this.$store.getters.boardCreator;
    },
  },

  mounted() {
    this.$diamond.getDashboardLayouts().then((res) => {
      this.$store.commit("setLayoutCollection", res.data);
    });
  },

  methods: {
    splitCamelCaseToString(s) {
      return s.split(/(?=[A-Z])/).join(" ");
    },

    saveLayout() {
      var controlsToSave = [];
      this.$eventHub.$emit('saving');
      
      for (let i = 0; i < this.$store.getters.controls.length; i++) {
        var save = { ...this.$store.getters.controls[i] };
        save.component = this.splitCamelCaseToString(save.component.name);
        controlsToSave.push(save);
      }

      var toSave = {
        controls: controlsToSave,
      };

      let createNew = false;
      let id = this.existingId;
      if (this.boardName && !this.willOverwrite) createNew = true;
      else if (this.willOverwrite) {
        var index = this.existingNames.findIndex(
          (x) => x.name == this.boardName
        );
        if (index == -1) return;
        id = this.existingNames[index].id;
      }

      var saveName = this.boardName ? this.boardName : this.existingName;
      if (createNew)
        this.$diamond
          .createLayout(saveName, JSON.stringify(toSave))
          .then((x) => {
            id = x.data;
            this.$store.commit("setCurrentLayout", id);
          });
      else {
        this.$diamond
          .saveLayout(id, saveName, JSON.stringify(toSave))
          .then((x) => {
            id = x.data;
            this.$store.commit("setCurrentLayout", id);
          });
      }

      this.$store.commit("setBoardName", saveName);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  background-color: rgba(48, 48, 48, 0.35);
}

.select-container {
  min-height: 10vh;
  width: 500px;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.close-btn {
  align-self: flex-end;
  cursor: pointer;
}

.content {
  display: grid;
  grid-template-columns: [labels] auto [controls] 1fr;
  grid-auto-flow: row;
  grid-gap: 0.8em;
  padding: 1.2em;
}

label {
  grid-column: labels;
  grid-row: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

input,
textarea,
.content button {
  grid-column: controls;
  grid-row: auto;
  border: none;
  padding: 1em;
}

input {
  border: 1px solid #303030;
}

.save-btn {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #0186c9;
  width: 100%;
  border: 0;
  padding: 15px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}
.save-btn:hover,
.save-btn:active,
.save-btn:focus {
  background: #8bc8dd;
}

.top-text {
  padding: 10px 30px;
}
</style>